import React from 'react';
import { Outlet } from 'react-router-dom';
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components';
import { darkTheme, lightTheme } from './theme';
import { useRecoilValue } from 'recoil';
import Header from './components/Header';
import { isModeAtom } from './atom';

const GlobalStyle = createGlobalStyle`
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, menu, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
main, menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, main, menu, nav, section {
  display: block;
}
/* HTML5 hidden-attribute fix for newer browsers */
*[hidden] {
    display: none;
}
body {
  line-height: 1;
}
menu, ol, ul {
  list-style: none;
}
blockquote, q {
  quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
* {
  box-sizing: border-box;
  
}
body {
  font-weight: 300;
  font-family: "Almendra", serif;
  background: linear-gradient(to bottom, ${props => props.theme.bgColor}, #2f3640); /* 그라데이션 배경 */
  color:${(props) => props.theme.textColor};
  line-height: 1.2;
  // 가로스크롤 제어용
  max-width: 100%; 
  overflow-x: hidden;
}
a {
  text-decoration:none;
  color:inherit;
}
`;

function App() {

  const isMode = useRecoilValue(isModeAtom);

  return (
    <ThemeProvider theme={isMode === lightTheme ? lightTheme : darkTheme}>
      <GlobalStyle />
        <Header />
        <Outlet />
    </ThemeProvider>

  );
}

export default App;
